module.exports = __webpack_public_path__ + "static/media/RadioBg.59800d94.png";